'use strict';

const _ = require('lodash');
const {PARSER_ERRORS} = require('../constants');
const ParserError = require('../errors/ParserError');

module.exports = (input, config) => {
    _.defaults(config, {
        required: false,
        choices: [],
    });

    if (config.required && _.isNil(input)) {
        throw new ParserError(PARSER_ERRORS.REQUIRED);
    }

    const choice = _.find(config.choices, (element) => element.id === input);
    if (!choice) {
        throw new ParserError(PARSER_ERRORS.INVALID_CHOICE);
    }

    return choice.id;
};
